import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import type { DraftManual } from 'views/App/Portal/Policy/_types/manuals/draft';

export default function useManual(
  manualId?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<DraftManual, ServerErrorResponse>(
    ['manual', manualId],
    async () => {
      if (!manualId) {
        throw new Error('manualId is a required parameter');
      }

      try {
        const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${manualId}`;
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      keepPreviousData: false,
      enabled: !!manualId,
    }
  );
}
